import React, { useContext } from "react";
import { appContext } from "../App";
import CategoryList from "./CategoryList";
import ProductThumb from "./ProductThumb";
import SearchHeader from "./SearchHeader";

const getSearchParams = (query?: string) => {
  if (query) {
    const params = new URLSearchParams(window.location.search);
    params.set("rf", "kw");
    params.set("kw", query);
    return `/?${params.toString()}`;
  } else {
    return "/";
  }
};

function Layout() {
  const { query, result } = useContext(appContext);
  const params = getSearchParams(query);
  return (
    <React.Fragment>
      <div className="col-xs-12 col-sm-2" id="left-sidebar">
        {query && result && result.aggregations && (
          <CategoryList categories={result?.aggregations?.categories.buckets} />
        )}
      </div>
      <div className="col-xs-12 col-sm-10">
        {query && (
          <React.Fragment>
            <SearchHeader />
            <div className="row">
              <div className="col-xs-12">
                <hr />
              </div>
            </div>
            <div className="thumb">
              <div className="row">
                {result &&
                  result?.hits &&
                  result?.hits?.hits &&
                  result?.hits?.hits.map((hit) => (
                    <ProductThumb product={hit._source} key={hit._source.id} />
                  ))}
              </div>
              {result && result?.hits?.total.value > 12 && (
                <div className="row">
                  <div className="col-xs-12">
                    <div className="text-right">
                      <button
                        className="btn btn-info"
                        onClick={() => {
                          window.location.href = params;
                        }}
                      >
                        View All
                      </button>
                    </div>
                  </div>
                </div>
              )}
            </div>
          </React.Fragment>
        )}
      </div>
    </React.Fragment>
  );
}

export default Layout;
